export default "__VITE_ASSET__DrRxAaZU__"